// removed by extract-text-webpack-plugin
module.exports = {"logo":"logo___15qr0","sider":"sider___3jHXY","ligth":"ligth___Tqs9t","icon":"icon___2SNz7"};